<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <br />
    <h2>
      Obras
      <button data-toggle="modal" data-target="#nova-obra-modal" style="margin-left: 15px" type="button" class="btn btn-primary" @click="limparObra">
        <i class="fas fa-plus" style="margin-right: 5px"></i>
        Nova obra
      </button>
    </h2>
    <br />
    <!-- FILTROS -->
    <div class="row" style="width: 100%">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent="buscarObras()">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="input-group mb-3">
                      <input class="form-control" id="id" v-model="filtro" placeholder="Buscar obras" />

                      <span class="input-group-append">
                        <button @click="buscarObras()" style="border-radius: 2px" type="submit" class="btn btn-info">
                          <i class="fas fa-search" style="margin-right: 5px"></i>
                          Buscar
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 0px 0px 10px 0px; color: red" v-if="searchBuscado">Exibindo resultados para "{{ filtro }}"</div>

    <!-- TABELA DE OBRAS -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Obras</h3>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Imagem</th>
              <th>Informações</th>
              <th>Detalhes</th>
              <th>Publicação</th>
              <th>Comentários</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(obra, index) in obras" :key="obras" @contextmenu.prevent="onRightClick($event, obra)" @click="hideMenu()">
              <td data-label="Seq">{{ index + 1 }}</td>

              <td data-label="Id" style="text-align: center">
                <img
                  style="cursor: pointer"
                  data-toggle="modal"
                  data-target="#image-modal"
                  @click="obra_selecionada = obra"
                  width="100px"
                  height="120px"
                  :src="getImagePath(obra)"
                />
              </td>

              <td data-label="Informações">
                <strong>Biblioteca:</strong>
                {{ obra.biblioteca }}
                <br />
                <strong>Localização:</strong>
                {{ obra.localizacao }}
                <br />
              </td>

              <td data-label="Detalhes">
                <strong>Título:</strong>
                {{ obra.titulo }}
                <br />
                <strong>Autor principal:</strong>
                {{ obra.autor_principal }}
                <br />
                <strong>Autores secundários:</strong>
                {{ obra.autores_secundarios }}
                <br />
                <strong>Bloqueado:</strong>
                {{ convertTiny(obra.bloqueado) }}
                <br />
                <strong>Categoria:</strong>
                {{ obra.categoria }}
                <br />
              </td>

              <td data-label="Editora">
                <strong>Editora:</strong>
                {{ obra.editora }}
                <br />
                <strong>ISBN:</strong>
                {{ obra.isbn }}
                <br />
                <strong>Ano publicação:</strong>
                {{ obra.ano_publicacao }}
                <br />
              </td>

              <td data-label="Comentários">
                <textarea readonly="true" class="form-control" v-model="obra.comentarios" rows="3" cols="200" style="min-width: 150px"></textarea>
                <br />
              </td>

              <td data-label="Editar">
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a @click="selecionarObra(obra)" data-toggle="modal" data-target="#nova-obra-modal" class="dropdown-item">
                    <i class="fa-solid fa-pen"></i>
                    &nbsp;&nbsp; Editar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a @click="deletar(obra)" class="dropdown-item">
                    <i class="fa-solid fa-bars"></i>
                    &nbsp;&nbsp; Deletar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div class="dropdown-divider"></div>
          <a
            style="cursor: pointer"
            @click="selecionarObra(obra_selecionada)"
            class="dropdown-item"
            data-toggle="modal"
            data-target="#nova-obra-modal"
          >
            <i class="fa-solid fa-pen"></i>
            &nbsp;&nbsp; Editar
          </a>

          <div class="dropdown-divider"></div>
          <a style="cursor: pointer" @click="deletar(obra_selecionada)" class="dropdown-item">
            <i class="fa-solid fa-bars"></i>
            &nbsp;&nbsp; Deletar
          </a>
        </div>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + obras.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="1">1</option>
          <option :value="2">2</option>
          <option :value="7">7</option>
          <option :value="15">15</option>
          <option :value="25">25</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL -->
    <div
      class="modal fade"
      id="nova-obra-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>{{ titulo_modal }}</h4>
              <br />
              <div class="card card-primary">
                <div class="card-header">
                  <h3 class="card-title" style="color: white"></h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- BIBLIOTECA -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="biblioteca">Biblioteca</label>

                        <select id="biblioteca" v-model="formData.biblioteca" class="custom-select rounded-0">
                          <option value="AspiCur1">AspiCur1</option>
                          <option value="PostCur1">PostCur1</option>
                          <option value="SantCur1">SantCur1</option>
                        </select>

                        <span style="color: red" v-for="error in v$.biblioteca.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </span>
                      </div>
                    </div>

                    <!-- LOCALIZAÇÃO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="localizacao">Localização</label>
                        <input class="form-control" id="localizacao" v-model="formData.localizacao" />
                      </div>
                    </div>

                    <!-- TIPO OBRA -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="tipo_obra">Tipo obra</label>

                        <select id="biblioteca" v-model="formData.tipo_obra" class="custom-select rounded-0">
                          <option value="livro">Livro</option>
                          <option value="periodico">Periódico</option>
                          <option value="tcc">TCC</option>
                        </select>

                        <span style="color: red" v-for="error in v$.tipo_obra.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </span>
                      </div>
                    </div>

                    <!-- BLOQUEADO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="nome">Bloqueado</label>

                        <select class="custom-select rounded-0" id="endereco_estado" v-model="formData.bloqueado">
                          <option :value="0">Não</option>
                          <option :value="1">Sim</option>
                        </select>
                      </div>
                    </div>

                    <!-- TITULO -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="titulo">Título</label>
                        <input class="form-control" id="titulo" v-model="formData.titulo" />

                        <span style="color: red" v-for="error in v$.titulo.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </span>
                      </div>
                    </div>

                    <!-- AUTOR PRINCIPAL -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="titulo">Autor principal</label>
                        <input class="form-control" id="titulo" v-model="formData.autor_principal" />

                        <span style="color: red" v-for="error in v$.autor_principal.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </span>
                      </div>
                    </div>

                    <!-- AUTORES SECUNDÁRIOS -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="autores_secundarios">Autores secundários</label>
                        <input class="form-control" id="autores_secundarios" v-model="formData.autores_secundarios" />
                      </div>
                    </div>

                    <!-- ISBN -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="isbn">ISBN</label>
                        <input class="form-control" id="isbn" v-model="formData.isbn" />
                      </div>
                    </div>

                    <!-- EDITORA -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="editora">Editora</label>
                        <input class="form-control" id="editora" v-model="formData.editora" />
                      </div>
                    </div>

                    <!-- ANO PUBLICAÇÃO -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="ano_publicacao">Ano publicação</label>
                        <input class="form-control" id="ano_publicacao" v-model="formData.ano_publicacao" />
                      </div>
                    </div>

                    <!-- CATEGORIA -->
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="categoria">Categoria</label>
                        <input class="form-control" id="categoria" v-model="formData.categoria" />
                      </div>
                    </div>

                    <!-- COMENTARIOS -->
                    <div class="col-sm-8">
                      <div class="form-group">
                        <label for="comentarios">Comentários</label>
                        <input class="form-control" id="comentarios" v-model="formData.comentarios" />
                      </div>
                    </div>

                    <!-- FOTO -->
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label for="exampleInputFile">Foto</label>
                        <input class="form-control" type="file" @change="onChange" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button data-toggle="modal" class="btn btn-success" @click="validate">{{ titulo_btn }}</button>
                  <button style="margin-left: 15px" data-toggle="modal" id="cancelar" data-target="#nova-obra-modal" class="btn btn-danger">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade" id="image-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: #4a4949">
        <div class="modal-body">
          <img
            style="position: relative; max-height: 1700px; max-width: 1500px; object-fit: contain"
            :src="getImagePath(obra_selecionada)"
            class="product-image im"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["estados", "comitentes", "processos"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      obras: [],
      acao: "",
      titulo_btn: "",
      titulo_modal: "",
      obra_selecionada: "",
      max_page: 0,
    };
  },

  setup() {
    const formData = reactive({
      upload_files: "",
      biblioteca: "",
      localizacao: "",
      tipo_obra: "",
      titulo: "",
      autor_principal: "",
      autores_secundarios: "",
      isbn: "",
      editora: "",
      ano_publicacao: "",
      categoria: "",
      comentarios: "",
      bloqueado: 0,
    });

    const rules = computed(() => {
      return {
        titulo: { required },
        autor_principal: { required },
        biblioteca: { required },
        tipo_obra: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.buscarObras();
  },

  methods: {
    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, obra) {
      this.obra_selecionada = obra;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    limparObra() {
      this.titulo_btn = "Cadastrar";
      this.titulo_modal = "Nova obra";
      this.acao = "store";

      this.formData.upload_files = "";
      this.formData.biblioteca = "PostCur1";
      this.formData.localizacao = "";
      this.formData.tipo_obra = "";
      this.formData.titulo = "";
      this.formData.autor_principal = "";
      this.formData.autores_secundarios = "";
      this.formData.isbn = "";
      this.formData.editora = "";
      this.formData.ano_publicacao = "";
      this.formData.categoria = "";
      this.formData.comentarios = "";
      this.formData.bloqueado = 0;
    },

    selecionarObra(obra) {
      console.log("Selecionada");
      console.log(obra);

      this.titulo_btn = "Gravar";
      this.titulo_modal = "Editar obra ID " + obra.id;
      this.acao = "update";

      this.obra_selecionada = obra;
      this.formData.biblioteca = obra.biblioteca;
      this.formData.tipo_obra = obra.tipo_obra;
      this.formData.titulo = obra.titulo;
      this.formData.autor_principal = obra.autor_principal;
      this.formData.localizacao = obra.localizacao;
      this.formData.editora = obra.editora;
      this.formData.autores_secundarios = obra.autores_secundarios;
      this.formData.isbn = obra.isbn;
      this.formData.ano_publicacao = obra.ano_publicacao;
      this.formData.categoria = obra.categoria;
      this.formData.comentarios = obra.comentarios;
      this.formData.bloqueado = obra.bloqueado;
    },

    async validate() {
      const result = await this.v$.$validate();

      if (result) {
        document.getElementById("cancelar").click();

        if (this.acao == "store") {
          this.store();
        } else {
          this.update();
        }
      }
    },

    store() {
      this.isLoading = true;

      let fd = new FormData();
      fd.append("file", this.formData.upload_files);
      fd.append("titulo", this.formData.titulo);
      fd.append("autor_principal", this.formData.autor_principal);
      fd.append("biblioteca", this.formData.biblioteca);
      fd.append("localizacao", this.formData.localizacao);
      fd.append("tipo_obra", this.formData.tipo_obra);
      fd.append("autores_secundarios", this.formData.autores_secundarios);
      fd.append("isbn", this.formData.isbn);
      fd.append("editora", this.formData.editora);
      fd.append("ano_publicacao", this.formData.ano_publicacao);
      fd.append("comentarios", this.formData.comentarios);
      fd.append("bloqueado", this.formData.bloqueado);
      fd.append("categoria", this.formData.categoria);

      console.log("Cadastrando");
      console.log(fd);
      console.log(this.formData.upload_files);

      axios
        .post(`/admin/obra/store`, fd)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButton("Sucesso", "Obra cadastrada");
          //this.buscarObras();

          console.log("PULANDO PARA PAGINA "+this.max_page);
          this.selecionarPagina(this.max_page);
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    update() {
      this.isLoading = true;

      let fd = new FormData();
      fd.append("obra_id", this.obra_selecionada.id);
      fd.append("file", this.formData.upload_files);
      fd.append("titulo", this.formData.titulo);
      fd.append("tipo_obra", this.formData.tipo_obra);
      fd.append("autor_principal", this.formData.autor_principal);
      fd.append("biblioteca", this.formData.biblioteca);

      if (this.formData.editora) {
        fd.append("editora", this.formData.editora);
      }

      if (this.formData.categoria) {
        fd.append("categoria", this.formData.categoria);
      }

      if (this.formData.ano_publicacao) {
        fd.append("ano_publicacao", this.formData.ano_publicacao);
      }

      if (this.formData.comentarios) {
        fd.append("comentarios", this.formData.comentarios);
      }

      if (this.formData.bloqueado) {
        fd.append("bloqueado", this.formData.bloqueado);
      }

      if (this.formData.isbn) {
        fd.append("isbn", this.formData.isbn);
      }

      if (this.formData.localizacao) {
        fd.append("localizacao", this.formData.localizacao);
      }

      if (this.formData.autores_secundarios) {
        fd.append("autores_secundarios", this.formData.autores_secundarios);
      }

      console.log("Cadastrando");
      console.log(fd);

      axios
        .post(`/admin/obra/update`, fd)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Obra atualizada", "/admin");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onChange(e) {
      this.formData.upload_files = e.target.files[0];
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarObras();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarObras();
      }
    },

    buscarObras() {
      this.isLoading = true;

      let data = {
        id: this.id,
        inicio: this.inicio,
        filtro: this.filtro,
        tamanho: this.qtd_por_pagina,
      };

      console.log(data);

      if (this.filtro && this.filtro != "") {
        this.searchBuscado = true;
      } else {
        this.searchBuscado = false;
      }

      axios
        .post(`/admin/obras/search`, data)
        .then((response) => {
          this.isLoading = false;
          this.obras = response.data.obras;
          this.total = response.data.total;

          console.log("Obras");
          console.log(this.obras);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.caminho_foto;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarObras();
    },

    deletar(obra) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar a obra<br/><b>" + obra.titulo + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              obra_id: obra.id,
            };

            axios
              .post(`/admin/obra/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButton("Sucesso", "Obra deletada");
                this.buscarObras();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
